//* 组件库
import { $loading, $message } from "various-ui";
//* 私有组件
import type { FavoritesInput, FavoriteInput } from "../components";
export const useComposable = () => {
    //* 插件
    const i18n = useI18n();
    const route = useRoute();
    //* 响应式变量
    const refs = {
        collected: ref<boolean>(false),
    };

    //* 节点
    const nodes = {
        favorites: ref<InstanceType<typeof FavoritesInput>>(),
        favorite: ref<InstanceType<typeof FavoriteInput>>(),
    };

    //* 函数列表
    const methods = {
        //* 页面是否被收藏
        init: async () => {
            await api.server("Collected", "/api/collected", {
                method: "POST",
                headers: { "X-Token": useCookie("X-Token").value || "" },
                data: { url: route.fullPath },
                success: (response) => {
                    refs.collected.value = response.value?.collected;
                },
            });
        },

        //* 点击收藏
        collect: () => {
            if (useCookie("X-Token").value) {
                refs.collected.value ? methods.remove() : nodes.favorite.value?.open();
            } else {
                //* 跳转登录页面
                window.open(
                    `${useRuntimeConfig().public.SSO_APP_URL}?uid=${useRuntimeConfig().public.SSO_APP_UID}&lang=${i18n.locale.value}&redirect=${
                        location.href
                    }`,
                    "_self"
                );
            }
        },

        //* 新增收藏夹
        add: (response: { name: string; descript: string }) => {
            //* 调用接口修改数据
            $loading.open({ message: i18n.t("UnderLoad") });
            api.frontend("/api/user/favorites", {
                data: { ...response },
                method: "POST",
                headers: { "X-Token": useCookie("X-Token").value || "" },
                finally: () => $loading.close(),
                success: () => {
                    //* 关闭窗口
                    nodes.favorites.value?.close();
                    //* 打开选择弹窗
                    nodes.favorite.value?.open();
                },
            });
        },

        //* 新增收藏
        select: (response: { name: string; descript: string }) => {
            //* 调用接口修改数据
            $loading.open({ message: i18n.t("UnderLoad") });
            api.frontend("/api/user/favorite", {
                data: {
                    descript: response.descript,
                    source: response.name,
                    page: route.meta.type || "Other",
                    url: route.fullPath,
                },
                method: "POST",
                headers: { "X-Token": useCookie("X-Token").value || "" },
                finally: () => $loading.close(),
                success: () => {
                    //* 关闭窗口
                    nodes.favorite.value?.close();
                    refs.collected.value = true;
                },
            });
        },

        //* 取消收藏
        remove: () => {
            api.frontend("/api/collected/cancel", {
                data: { url: route.fullPath },
                method: "POST",
                headers: { "X-Token": useCookie("X-Token").value || "" },
                finally: () => $loading.close(),
                success: () => {
                    refs.collected.value = false;
                    $message.success(i18n.t("Success"));
                },
            });
        },
    };

    return { refs, nodes, methods };
};
